//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fromItems from "./mixin/fromItems";
export default {
  mixins: [fromItems],
  name: "cmDate",
  props: {
    popperclass: "",
    pickerOptions: {},
    startPlaceholder: {},
    endPlaceholder: {},
    defaultTime: "",
    label: {},
    type: {
      // type year/month/date/week/ datetime/datetimerange/daterange
      default: "date"
    },
    myvalueFormat: {
      default: "yyyy-MM-dd"
    },
    readonly: {},
    format: {},
    inline: {
      type: Boolean,
      default: true
    },
    startDate: String,
    endDate: String,
    vstyle: {}
  },
  data: function data() {
    return {
      value: ""
    };
  },
  mounted: function mounted() {
    this.setDate();
    if (this.type.indexOf("time") > 0) {
      this.myvalueFormat = "yyyy-MM-dd HH:mm:ss";
    }
  },
  methods: {
    dateChange: function dateChange(val) {
      this.$emit("dateChange", val);
    },
    setDate: function setDate() {
      if (this.type === "datetime" || this.type === "date" || this.type === "month" || this.type === "year" || this.type === "week") {
        this.value = this.startDate;
      } else if (this.startDate === "" || this.endDate === "") {
        this.value = "";
      } else {
        this.value = [this.startDate, this.endDate];
      }
    }
  },
  watch: {
    startDate: function startDate(newData, oldData) {
      this.setDate();
    },
    endDate: function endDate(newData, oldData) {
      this.setDate();
    },
    value: function value(newData, oldData) {
      var start = "";
      var end = "";
      if (this.type === "date" || this.type === "datetime" || this.type === "month" || this.type === "year" || this.type === "week") {
        start = newData || "";
        this.$emit("update:startDate", start);
      } else {
        start = newData ? newData[0] : "";
        end = newData ? newData[1] : "";
        this.$emit("update:startDate", start);
        this.$emit("update:endDate", end);
      }
    }
  }
};